interface TabNavigationProps {
  activeTab: 'active' | 'upcoming' | 'completed';
  onTabChange: (tab: 'active' | 'upcoming' | 'completed') => void;
}

export function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  const tabs = [
    { id: 'active' as const, label: 'Active' },
    { id: 'upcoming' as const, label: 'Upcoming' },
    { id: 'completed' as const, label: 'Completed' },
  ];

  return (
    <div className="flex border-b border-slate-200 dark:border-slate-700 px-4 justify-between">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex flex-col items-center justify-center border-b-[3px] pb-[13px] pt-4 flex-1 ${
            activeTab === tab.id
              ? 'border-b-primary text-slate-900 dark:text-white'
              : 'border-b-transparent text-slate-500 dark:text-slate-400'
          }`}
        >
          <p className="text-sm font-bold leading-normal tracking-[0.015em]">
            {tab.label}
          </p>
        </button>
      ))}
    </div>
  );
}
